/* ✍️ Kupon rabatowy — aktualizacja kwoty oszczędności po zmianie wariantu.
   Ładowany przez snippets/lp-coupon.liquid.

   Motyw przy zmianie wariantu dociąga świeży HTML sekcji, ale przepisuje z niego tylko
   elementy z zamkniętej listy (product-info.js → updateSourceFromDestination); bloku
   lp_coupon na tej liście nie ma. Zamiast dopisywać się do pliku motywu, bierzemy kwotę
   z tego samego dokumentu — dzięki czemu formatowanie waluty zostaje po stronie Liquid
   i wielowalutowość działa bez liczenia czegokolwiek w JS. */
if (!customElements.get('lp-coupon')) {
  customElements.define(
    'lp-coupon',
    class LpCoupon extends HTMLElement {
      connectedCallback() {
        this.save = this.querySelector('[data-lp-save]');
        if (!this.save || !window.FoxTheme?.pubsub) return;

        this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = event?.data?.sectionId;
          if (sectionId && this.dataset.sectionId && sectionId !== this.dataset.sectionId) return;

          const source = event?.data?.html?.querySelector('lp-coupon [data-lp-save]');
          if (!source) return;

          this.save.innerHTML = source.innerHTML;
          this.save.toggleAttribute('hidden', source.hasAttribute('hidden'));
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    }
  );
}
